module.exports = __webpack_public_path__ + "static/media/campo-grande-ms.53db8642.jpg";